// Para/tutar inputları için ortak yardımcılar.
// Kullanıcı hem "50,5" (Türkçe ondalık virgülü) hem de "50.5" yazabilmeli;
// kuruş/ondalık desteği sağlanmalı. Bu dosya tek noktadan bu işi yönetir.

// Serbest girişi (ör. "1.250,75" veya "1,250.75" veya " 50,5 ")
// JS Number'a çevirir. Geçersizse NaN döner.
export const parseMoneyInput = (value) => {
  if (value === null || value === undefined) return NaN;
  if (typeof value === 'number') return value;

  let str = String(value).trim();
  if (str === '') return NaN;

  // Para birimi işaretleri ve boşluklar temizlensin
  str = str.replace(/[₺$€\s]/g, '');

  const hasComma = str.includes(',');
  const hasDot = str.includes('.');

  if (hasComma && hasDot) {
    // Son gelen ayraç ondalık kabul edilir; diğeri binlik ayıracıdır.
    const lastComma = str.lastIndexOf(',');
    const lastDot = str.lastIndexOf('.');
    if (lastComma > lastDot) {
      // "1.250,75" -> "1250.75"
      str = str.replace(/\./g, '').replace(',', '.');
    } else {
      // "1,250.75" -> "1250.75"
      str = str.replace(/,/g, '');
    }
  } else if (hasComma) {
    // Sadece virgül var -> ondalık ayırıcı olarak kabul et.
    str = str.replace(',', '.');
  }
  // Sadece nokta varsa zaten JS okuyabilir.

  const num = Number(str);
  return Number.isFinite(num) ? num : NaN;
};

// Input onChange içinde kullanılır: kullanıcı yazarken sadece
// rakam, nokta, virgül ve eksi işaretine izin verir. Görünen değer olduğu gibi kalır,
// sayıya dönüştürme submit anında parseMoneyInput ile yapılır.
export const sanitizeMoneyInput = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[^0-9.,\-]/g, '');
};
